<template>
    <!-- TODO:replace with <dialog> when supported on safari/edge -->
    <div class="modal-container" :class="{ fill }"><slot></slot></div>
</template>

<script>
export default {
    props: ["fill"]
};
</script>

<style lang="scss" scoped>
.modal-container {
    background-color: white;
    margin: 20px 40px;
    justify-self: center;
    align-self: center;

    &.fill {
        flex-grow: 1;
        align-self: stretch;
    }
}
</style>



// WEBPACK FOOTER //
// modal-container.vue?7c4ce875